// @ts-nocheck

import AuthManager from '@winamax/auth-manager';

import { authActionCreators } from '../actions';
import { getWapiDynamicEndpoint } from '../config/urls';

let authManager = null;

export const createAuthManager = (dispatch) => {
  const onTokenGeneratedCallback = (jwt, expirationDelay) => {
    dispatch(authActionCreators.receivedToken(jwt, expirationDelay));
  };

  const onTokenRefreshCallback = (jwt, expirationDelay) => {
    dispatch(authActionCreators.receivedToken(jwt, expirationDelay));
  };

  const onTokenExpireCallback = () => {
    dispatch(authActionCreators.invalidateToken());
  };

  authManager = new AuthManager({
    authApiEndpoint: getWapiDynamicEndpoint(),
    listeners: { onTokenGeneratedCallback, onTokenRefreshCallback, onTokenExpireCallback },
  });
};

export const getAuthManager = () => authManager;
